import { CreditProgress } from '@aibees/shared/components';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useCurrentPlanInfo } from '@aibees/shared/features/price-and-plan/hooks/use-current-plan-info';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountPopoverCreditItemProps as Props } from './types';

export const AccountPopoverCreditItem = memo(
  ({ className, type, subscription }: Props) => {
    const { data } = useCurrentSubscriptionApi();
    const { credit, rollOver } = useCurrentPlanInfo();

    return (
      <Styled.Wrapper
        className={classnames('AccountPopoverCreditItem', className)}
        sx={SX.root}
      >
        <Stack gap={2}>
          <CreditProgress
            type="Credit"
            charged={Number(data?.current?.plan?.metadata.request)}
            remaining={credit}
            showWarning
          />
          {!data?.current?.plan?.metadata.is_free && (
            <CreditProgress
              type="Roll Over"
              charged={Number(data?.current?.plan?.metadata.rollover)}
              remaining={rollOver}
              showWarning
            />
          )}
        </Stack>
      </Styled.Wrapper>
    );
  }
);

AccountPopoverCreditItem.displayName = 'AccountPopoverCreditItem';
